/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================
*/

function collapseItem(theme, ownerState) {
  const { palette, transitions, breakpoints, boxShadows, borders, functions } = theme;
  const { active, transparentSidenav, whiteSidenav, darkMode, sidenavColor, miniSidenav } = ownerState;

  const { white, transparent, dark, grey, gradients } = palette;
  const { md } = boxShadows;
  const { borderRadius } = borders;
  const { pxToRem, rgba, linearGradient } = functions;

  return {
    background: active
      ? linearGradient(gradients[sidenavColor].main, gradients[sidenavColor].state)
      : transparent.main,
    color:
      (transparentSidenav && !darkMode && !active) || (whiteSidenav && !active)
        ? dark.main
        : white.main,
    display: "flex",
    alignItems: "center",
    width: "100%",

    // 🔥 1. INCREASED BOX SIZE (PADDING)
    // Was: 8px 10px -> Now: 12px 16px
    padding: `${pxToRem(12)} ${pxToRem(16)}`,

    // Left Shift Logic (Preserved)
    margin: `${pxToRem(1)} ${pxToRem(10)} ${pxToRem(1.5)} ${pxToRem(4)}`,

    borderRadius: borderRadius.md,
    cursor: "pointer",
    userSelect: "none",
    whiteSpace: "nowrap",
    boxShadow: active && !whiteSidenav && !darkMode && !transparentSidenav ? md : "none",
    
    // Layout: Column for Icon on top, Text below
    flexDirection: miniSidenav ? "column" : "row",
    justifyContent: "center",

    [breakpoints.up("xl")]: {
      transition: transitions.create(["box-shadow", "background-color"], {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.shorter,
      }),
    },

    "&:hover, &:focus": {
      backgroundColor: () => {
        let backgroundValue;

        if (!active) {
          backgroundValue =
            transparentSidenav && !darkMode
              ? grey[300]
              : rgba(whiteSidenav ? grey[400] : white.main, 0.2);
        }

        return backgroundValue;
      },
    },
  };
}

function collapseIconBox(theme, ownerState) {
  const { palette, transitions, borders, functions } = theme;
  const { transparentSidenav, whiteSidenav, darkMode, active, miniSidenav } = ownerState;

  const { white, dark } = palette;
  const { borderRadius } = borders;
  const { pxToRem } = functions;

  return {
    // 🔥 2. INCREASED ICON CONTAINER SIZE
    // Was: 32px -> Now: 46px (Large square)
    minWidth: pxToRem(46),
    minHeight: pxToRem(46),

    color:
      (transparentSidenav && !darkMode && !active) || (whiteSidenav && !active)
        ? dark.main
        : white.main,
    borderRadius: borderRadius.md,
    display: "grid",
    placeItems: "center",
    
    // Margins
    marginRight: miniSidenav ? 0 : pxToRem(10),
    marginBottom: miniSidenav ? pxToRem(6) : 0, // Increased spacing between icon and text

    transition: transitions.create("margin", {
      easing: transitions.easing.easeInOut,
      duration: transitions.duration.standard,
    }),

    "& svg, svg g": {
      color: transparentSidenav || whiteSidenav ? dark.main : white.main,
    },
  };
}

const collapseIcon = ({ palette: { white, gradients } }, { active }) => ({
  color: active ? white.main : gradients.dark.state,
  // 🔥 3. INCREASED ACTUAL ICON FONT SIZE
  fontSize: "1.6rem !important", 
});

function collapseText(theme, ownerState) {
  const { typography, transitions, breakpoints, functions } = theme;
  const { miniSidenav, active } = ownerState;

  const { size, fontWeightRegular, fontWeightLight } = typography;
  const { pxToRem } = functions;

  return {
    marginLeft: miniSidenav ? 0 : pxToRem(10),

    [breakpoints.up("xl")]: {
      opacity: 1, 
      maxWidth: "100%", 
      marginLeft: miniSidenav ? 0 : pxToRem(10),
      transition: transitions.create(["opacity", "margin"], {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.standard,
      }),
    },

    "& span": {
      fontWeight: active ? fontWeightRegular : fontWeightLight,
      fontSize: miniSidenav ? pxToRem(11) : size.sm, // Slightly larger text to match box
      lineHeight: 0,
    },
  };
}

export { collapseItem, collapseIconBox, collapseIcon, collapseText };